import styled from "@emotion/styled";
import {ReactComponent as teleYellowGreen} from "../../../../images/800CallLogs/Resources for Call Logs/TelephoneYellowGreen.svg"

export const TelephoneYellowGreenSvg = styled(teleYellowGreen)`
     width: 50.53px;
     height: 49.47px;
`;